import React, { useEffect, useState } from 'react'
import { Alert, Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'
import PropTypes from 'prop-types'
import { useFormik } from 'formik'
import { RuleActionSchema } from '../../../utils/validation'

const formatOptions = (actions) => actions.map((action) => {
  let selector = action.description

  if ([1, 3, 5].includes(action.actionTypeId)) {
    selector = `${selector} [${action.orderKey}]`
  }

  return {
    ...action,
    selector
  }
})

const AddActionModal = ({ show, onClose, rule, actions, addRuleActionState, onSubmit }) => {
  const [showAlert, setShowAlert] = useState(false)

  useEffect(() => {
    if (addRuleActionState.error !== false) {
      setShowAlert(true)
    }
  }, [addRuleActionState.error])

  const addAction = useFormik({
    initialValues: {
      selector: []
    },
    enableReinitialize: true,
    validationSchema: RuleActionSchema,
    onSubmit: (values, { resetForm }) => {
      onSubmit(values)
      resetForm()
    }
  })

  return (
    <Modal
      size="lg"
      show={show}
      onHide={onClose}
      backdrop='static'
      keyboard={false}
    >
      <Modal.Header closeButton>
        <h4>Add Action</h4>
      </Modal.Header>
      <Form id='form' noValidate onSubmit={addAction.handleSubmit}>
        <Modal.Body>
          <Row>
            <Col xs={12}>
              <p>
                {rule.description}
              </p>
            </Col>
            <Col xs={12}>
              <Alert variant='danger' show={showAlert} dismissible onClose={() => setShowAlert(false)}>
                {addRuleActionState.error.message}
              </Alert>
            </Col>
            <Col xs={12}>
              <Form.Group as={Col} xs={12}>
                <Form.Label>Action</Form.Label>
                <Typeahead
                  id='rule-action-select'
                  type='text'
                  labelKey='selector'
                  placeholder='Select available action'
                  selected={addAction.values.selector}
                  onChange={(selected) => {
                    addAction.setTouched('selector')
                    addAction.setFieldValue('selector', selected)
                  }}
                  isInvalid={!!addAction.errors.selector && addAction.touched.selector}
                  options={formatOptions(actions)}
                />
                {
                  !!addAction.errors.selector && addAction.touched.selector && (
                    <Form.Text className='red-font'>
                      {addAction.errors.action}
                    </Form.Text>
                  )
                }
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='outline-secondary' onClick={onClose}>
            Cancel
          </Button>
          <Button type='submit' disabled={addRuleActionState.loading}>
            {
              addRuleActionState.loading ? <Spinner animation='border' role='status' size='sm' />  : 'Add Action to Rule'
            }
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

AddActionModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  rule: PropTypes.shape({
    description: PropTypes.string
  }),
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      label: PropTypes.string,
      description: PropTypes.string
    })
  ),
  onSubmit: PropTypes.func,
  addRuleActionState: PropTypes.shape({
    loading: PropTypes.bool,
    success: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
      PropTypes.shape({
        message: PropTypes.string
      })
    ])
  }),
}

export default AddActionModal
